import { atomWithReset } from "jotai/utils";

export const hasUnityLoadedOnceAtom = atomWithReset(false);
